<template>
  <!-- Tabs: start -->
  <div class="part col-sm-12">
    <div class="portfolio-nav col-sm-12" id="filter-button">
      <ul>
        <tab
          v-for="(category, index) in categories"
          :name="category"
          :key="`${index}.${category}`"
          :filter="`${
            category == '*' || category == 'All'
              ? '*'
              : `.${$helper.slugify(category)}`
          }`"
        >
          <span v-html="category"></span>
        </tab>
      </ul>
    </div>

    <!-- Tab Details: start -->
    <div
      class="mh-project-gallery col-sm-12 wow fadeInUp"
      id="project-gallery"
      data-wow-duration="0.8s"
      data-wow-delay="0.5s"
    >
      <div class="portfolioContainer row">
        <slot></slot>
      </div>
    </div>
    <!-- End: .grid .project-gallery -->
  </div>
  <!-- End: .part -->
</template>

<script>
import Tab from "@/components/Portfolio/Tab.vue";

export default {
  data() {
    return {
      tabs: [],
    };
  },

  props: {
    categories: {
      required: true,
      type: Array,
      default: () => {},
    },
  },

  watch: {
    categories() {
      // Convert the firebase Tab Type (String) to Object
      // and set the parameter selected to false
      // Set the "All Category" tab as the current tabß
      this.tabs = this.categories.map((name) => ({
        name: name,
        selected:
          name.includes("all") || name.includes("*") || name.includes("All"),
      }));
    },
  },

  components: {
    Tab,
  },
};
</script>
